import script from "./faq.vue?vue&type=script&setup=true&lang=js"
export * from "./faq.vue?vue&type=script&setup=true&lang=js"

import "./faq.vue?vue&type=style&index=0&id=45f781aa&scoped=true&lang=scss"

import exportComponent from "/Users/windy/work/vue/zhibo_am/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45f781aa"]])

export default __exports__